export const introData = {
    description: "<p><strong>Toke es una billetera digital</strong> respaldada por Banco Popular, que te permite mover tu dinero de forma simple, rápida y segura. Paga y cobra al instante con tu <strong>número de celular</strong> o <strong>código QR</strong>.</p><p>Descarga la App o activa el botón de pagos Toke en las Apps Popular y Qik.</p>",
    link: "Conocer más",
    url: "www.google.com"
};
